import { createSlice } from "@reduxjs/toolkit";

const currencySlice = createSlice({
  name: "currency",
  initialState: {
    currencyName: "", // Store API response here
  },
  reducers: {
    setcurrency(state, action) {
      state.currencyName = action.payload; // Update state correctly
    },
  },
});

export const { setcurrency } = currencySlice.actions;
export default currencySlice.reducer;
